var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarOutline(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#E5C1DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.287 14.195c.224-.69 1.202-.69 1.426 0l3.384 10.415c.1.31.389.519.714.519h10.95c.727 0 1.03.93.442 1.356l-8.86 6.437a.75.75 0 00-.273.839l3.385 10.415c.224.691-.567 1.266-1.154.839l-8.86-6.437a.75.75 0 00-.882 0l-8.86 6.437c-.587.427-1.378-.148-1.154-.839l3.384-10.415a.75.75 0 00-.272-.839l-8.86-6.437c-.587-.427-.285-1.356.441-1.356H25.19a.75.75 0 00.714-.519l3.384-10.415z",
    stroke: "#000",
    strokeWidth: 2
  })));
}
export default SvgStarOutline;